var Kowloon = "Kowloon";
var HKStates = {
	"Hong Kong Island": "Isola di Hong Kong",
	Kowloon: Kowloon,
	"Lantau Island": "Isola di Lantau",
	"New Territories": "Nuovi territori"
};

export { Kowloon, HKStates as default };
